import React, { ComponentProps } from 'react'
import { Text } from 'components/Text'
import { IconName } from 'components/Icon/iconNames'
import {
  Checkmark,
  RadioGroupIndicator,
  RadioGroupOption,
  RadioGroupRoot,
  RadioGroupStack,
} from './RadioGroup.styles'

type RadioGroupOwnProps = ComponentProps<typeof RadioGroupRoot>

export type Option = {
  label: string
  value: string
  icon: IconName
}

export type RadioGroupProps = RadioGroupOwnProps & {
  label: string
  displayLabel?: boolean
  name: string
  onValueChange: (value: string) => void
  direction?: 'row' | 'column' | any
  pill?: boolean
}

const RadioGroupComponent = ({
  label,
  displayLabel = true,
  name,
  onValueChange,
  children,
  direction = 'row',
  pill = false,
  ...rest
}: RadioGroupProps) => {
  return (
    <RadioGroupRoot pill={pill} aria-label={label} name={name} onValueChange={onValueChange} {...rest}>
      {displayLabel && (
        <Text as="label" size="headline" weight="bold" align="center">
          {label}
        </Text>
      )}
      <RadioGroupStack
        alignItems="flex-start"
        justifyContent="center"
        direction={direction}
        gap={{ '@initial': '1', '@bp1': '2', '@bp2': '3' }}
      >
        {children}
      </RadioGroupStack>
    </RadioGroupRoot>
  )
}

const Indicator = (props: { forceMount?: true }) => {
  return (
    <RadioGroupIndicator {...props}>
      <Checkmark />
    </RadioGroupIndicator>
  )
}

export const RadioGroup = {
  Root: RadioGroupComponent,
  Option: RadioGroupOption,
  Indicator: Indicator,
}
